
import React, { useState } from 'react'
import { FaGraduationCap, FaBars } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { HiMiniBars3BottomLeft } from "react-icons/hi2";
import { HiBars3 } from "react-icons/hi2";

import MobileNav from './MobileNav';


const Nav = () => {
    const [show, setShow] = useState(false)
    const handleShowState = () => {
        setShow(true)
    }
    const handleHideState = () => {
        setShow(false)
    }

    window.addEventListener('scroll', (e) => {
      //  console.log(e.currentTarget);
        if(e.currentTarget.scrollY >= 320) {
            document.body.classList.add('show-nav')
        } else {
            document.body.classList.remove('show-nav')
        }
        
    })
  return (
    <header className={show === true ? "py-0 header bg-white w-[100%] fixed" : 'header bg-white w-[100%] py-4 fixed'}>
        <section className='flex justify-between w-[90%] mx-auto'>
            <div className={show === true ? "my-auto hidden" : 'flex my-auto'}>
                <Link to="/"><span className='bg-[#E57853] w-[30px] h-[30px] flex justify-center items-center rounded-lg'>
                <FaGraduationCap color='white' />
                </span></Link>
                <Link to="/">
                <span className='text-[#6A57AA] ml-2 font-medium text-2xl logo'>Quest-Inspire</span>
                </Link>
            </div>
            <nav className='my-auto w-[36%] md:hidden'>
<ul className='flex justify-between' >
    <li>
        <Link to="/" className='text-[#3D3939] hover:text-[#5E4FAC] logo font-normal text-base'>Home</Link> </li>
       <li> <Link to="/about" className='text-[#3D3939] hover:text-[#5E4FAC] logo font-normal text-base'>About</Link></li>
       <li>  <Link to="/services" className='text-[#3D3939] hover:text-[#5E4FAC] logo font-normal text-base'>Service</Link></li>
       <li> <Link to="/contact" className='text-[#3D3939] hover:text-[#5E4FAC] logo font-normal text-base'>Contact</Link></li>
       <li> <Link to="/admissions" className='text-[#3D3939] hover:text-[#5E4FAC] logo font-normal text-base'>Admission</Link></li>
    
</ul>
            </nav>
            <section className='md:hidden'>
                <button className='mr-4 text-[#1E1D1D] text-base font-normal logo'>Admin</button>
                <button className='bg-[#5146AE] rounded-lg text-white w-[159px] h-[56px] font-medium text-base'>Student</button>
            </section>
            <section className={show === true ? "hidden" : 'my-auto hidden md:block'} onClick={handleShowState}>
                <FaBars  className='w-[30px] h-[25px] bars text-[#6A57AA]' />
            </section>
            
        </section>
        <MobileNav handleHideState={handleHideState} show={show} />
    </header>
  )
}


export default Nav